import React, { useContext } from 'react'

import { TimeWindowSelectorContext } from '../../contexts/TimeWindowSelectorContext';


export const TimeWindowSelectorForm = () => {
  const {state, dispatch} = useContext(TimeWindowSelectorContext);

  const handleInputValueChanged = (event) => {
    if (event.target && event.target.name) {
      const {name, value} = event.target
      dispatch({
        type: 'SET_VALUE',
        key: name,
        value,
      })
    }
  }

  return (
    <>
      <div className="datetimebox">
        <div className="clearfix datetimebox_inner">
          <div className="clearfix inline-block">
            <input type="text" name="startTime"
              placeholder="2022-01-01 10:00:00" className="multiinput inputlg"
              title="입력 형식:&#10;2022-01-01&#10;2022-01-01 10:00:00&#10;2022-01-01 10:00:00.000"
              aria-label="자료 시작시간"
              onBlur={handleInputValueChanged}
            />
          </div>
          <div className="clearfix inline-block">
            <span className="center-align">&nbsp;&nbsp; ~ &nbsp;&nbsp;</span>
            <input type="text" name="endTime"
              placeholder="2022-01-01 10:30:00" className="multiinput inputlg"
              title="입력 형식:&#10;2022-01-01&#10;2022-01-01 10:30:00&#10;2022-01-01 10:30:00.000"
              aria-label="자료 종료시간"
              onBlur={handleInputValueChanged}
            />
          </div>
        </div>
      </div>
      <div className="left">
        Timezone: &nbsp;&nbsp;
        <label className="datatable_select_radio" htmlFor="timeWindowSelectorForm.timezone.KST">
          <input type="radio" id="timeWindowSelectorForm.timezone.KST" className="with-gap"
            name="timezone" value="KST"
            checked={state.timezone === 'KST'}
            onChange={handleInputValueChanged}
          />
          <span>KST &nbsp;&nbsp;&nbsp;</span>
        </label>
        <label className="datatable_select_radio" htmlFor="timeWindowSelectorForm.timezone.UTC">
          <input type="radio" id="timeWindowSelectorForm.timezone.UTC" className="with-gap"
            name="timezone" value="UTC"
            checked={state.timezone === 'UTC'}
            onChange={handleInputValueChanged}
          />
          <span>UTC &nbsp;&nbsp;&nbsp;</span>
        </label>        
      </div>
    </>
  )
}

